import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Copyright from "../component/Copyright";
import { useLocation, useNavigate } from 'react-router-dom';
import { regist } from '../lib/api';

export default function SignUp() {

  const navigate = useNavigate();
  const routerParams = useLocation().state||{};
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const flag = await regist(data);
    if(flag){
      const redirect = routerParams.redirect||"/console/dashboard";
      navigate(redirect);
    }
  };
  // 获取其他组件传过来的参数，并设置到state中
  const [email,setEmail] = React.useState(useLocation().state?.email||"");  // 一定要有明确的初始值
  const [mobile,setMobile] = React.useState("");
  const [nickname,setNickname] = React.useState("");

  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            注册
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  name="nickname"
                  required
                  fullWidth
                  value={nickname}
                  onChange={(event)=>{setNickname(event.currentTarget.value)}}
                  id="nickname"
                  label="昵称"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  value={email}
                  onChange={(event)=>{setEmail(event.currentTarget.value)}}
                  id="mail"
                  label="邮件地址"
                  name="mail"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  value={mobile}
                  onChange={(event)=>{setMobile(event.currentTarget.value)}}
                  id="mobile"
                  label="手机号"
                  name="mobile"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox checked value="allowExtraEmails" color="primary" />}
                  label="允许系统向您发送通知邮件."
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              注册
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link href="/signin" variant="body2">
                  已有账户？登录
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
  );
}